import React, { useEffect } from 'react'
import "./verifyIdentity.scss"
import { VerifyIdentityInfo } from '../../components'
import { useNavigate, useLocation } from 'react-router-dom'

const VerifyIdentity = () => {
  const navigate = useNavigate();

  const location = useLocation();
  
  useEffect(() => {
    // Replace the current history entry with the same URL
    // This prevents going back with the browser back button
    window.history.replaceState(null, '', location.pathname);
    
    // Push the login page as the only place to go back to
    window.history.pushState(null, '', location.pathname);
    
    const handlePopState = () => {
      // When back button is clicked, redirect to login
      navigate('/login');
    };
    
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate, location.pathname]);

  return (
    <div className='verify-identity-section'>
      <VerifyIdentityInfo />
    </div>
  )
}

export default VerifyIdentity